import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import type { NavigationGroup } from "./navigation";

export function SidebarNavigation({
  groups,
  collapsed,
}: {
  groups: readonly NavigationGroup[];
  collapsed: boolean;
}) {
  const { t } = useTranslation();
  return (
    <nav className="sidebar-navigation menu menu-sm w-full p-0" aria-label={t("shell.navigation.label")}>
      {groups.map((group) => (
        <div className="nav-group" key={group.key}>
          <span className="nav-section">{t(`shell.navigation.groups.${group.key}`)}</span>
          <div className="nav-items">
            {group.items.map(({ to, key, icon: Icon }) => {
              const label = t(`shell.navigation.items.${key}.label`);
              const description = t(`shell.navigation.items.${key}.description`);
              return (
                <NavLink
                  key={to}
                  to={to}
                  title={collapsed ? `${label} — ${description}` : undefined}
                  aria-label={`${label}. ${description}`}
                  className={({ isActive }) => (isActive ? "active" : "")}
                >
                  <Icon aria-hidden="true" />
                  <span className="nav-copy">
                    <span>{label}</span>
                    <small>{description}</small>
                  </span>
                </NavLink>
              );
            })}
          </div>
        </div>
      ))}
    </nav>
  );
}
